import React from "react";
import { Container } from "react-bootstrap";


const Error = () => {
    return (
        <Container>
            <div className="text-center mt-5 pt-5" style={{ height: "600px" }}>
                <div className=" mt-5 pt-5">
                    <h1>404 Error</h1>
                    <p>Page Not found</p>
                </div>
            </div>
        </Container>
    )
}

export default Error;